import { render, staticRenderFns } from "./ServiceTagForm.vue?vue&type=template&id=50db86e5&scoped=true&"
import script from "./ServiceTagForm.vue?vue&type=script&lang=ts&"
export * from "./ServiceTagForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db86e5",
  null
  
)

export default component.exports